import { gql } from "@apollo/client";

export const DOCUMENT_CREATE = gql`
  mutation DocumentCreate($input: DocumentFieldsInput!) {
    documentCreate(input: $input) {
      label
      message
      document {
        id
        title
        slug
        active
        placement
        row_order
        getFileUrl
      }
    }
  }
`;

export const DOCUMENT_UPDATE = gql`
  mutation DocumentUpdate($input: DocumentFieldsInput!) {
    documentUpdate(input: $input) {
      label
      message
      document {
        id
        title
        slug
        active
        placement
        row_order
        getFileUrl
      }
    }
  }
`;

export const DOCUMENT_DELETE = gql`
  mutation DocumentDelete($id: ID!) {
    documentDelete(id: $id) {
      label
      message
    }
  }
`;

export const DOCUMENT_ORDER = gql`
  mutation DocumentOrder($input: DocumentFieldsInput!) {
    documentUpdate(input: $input) {
      document {
        id
        row_order
      }
    }
  }
`;
